// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yrq20","content":"styles_content__sdRC3"};